export default "__VITE_ASSET__578054ac__"